import {ListItemIcon, ListItemText, MenuItem} from "@mui/material";
import {logout} from "../../shared/keycloak";
import IconBadge from "../icon-badge/IconBadge";

function Logout() {
    function handleLogout() {
        logout();
    }

    return (
        <MenuItem onClick={handleLogout}>
            <ListItemIcon sx={{minWidth: 46}}>
                <IconBadge size={32}>logout</IconBadge>
            </ListItemIcon>
            <ListItemText>Sair</ListItemText>
        </MenuItem>
    );
}

export default Logout;
